import React, { useContext, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { CompanyProfileContext } from "../../../CustomContext";
import { ThemeContext } from "../../../context/ThemeContext";
import LogoutPage from "./Logout";
const Header = ({ onNote }) => {
  const { setCompanyProfile } = useContext(CompanyProfileContext);
  const { changeBackground } = useContext(ThemeContext);
  useEffect(() => {
    // changeBackground({ value: "dark", label: "Dark" });
  }, []);
  useEffect(() => {
    
      const dataLocalStorage = JSON.parse(
        window.localStorage.getItem("userDetails")
      );
      const { companyProfile } = dataLocalStorage;
      setCompanyProfile(companyProfile);
    
  }, []);

  //For fix header
  const [headerFix, setheaderFix] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setheaderFix(window.scrollY > 50);
    });
  }, []);

  const [profileInfo, setProfileInfo] = useState({});
  useEffect(() => {
    const savedInStorage = JSON.parse(localStorage.getItem("userDetails"));

    if (savedInStorage) {
      setProfileInfo(savedInStorage.companyProfile);
    }
  }, []);

  //const [searchBut, setSearchBut] = useState(false);
  var path = window.location.pathname.split("/");
  var name = path[path.length - 1].split("-");
  var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
  var finalName = filterName.includes("app")
    ? filterName.filter((f) => f !== "app")
    : filterName.includes("ui")
    ? filterName.filter((f) => f !== "ui")
    : filterName.includes("uc")
    ? filterName.filter((f) => f !== "uc")
    : filterName.includes("basic")
    ? filterName.filter((f) => f !== "basic")
    : filterName.includes("jquery")
    ? filterName.filter((f) => f !== "jquery")
    : filterName.includes("table")
    ? filterName.filter((f) => f !== "table")
    : filterName.includes("page")
    ? filterName.filter((f) => f !== "page")
    : filterName.includes("email")
    ? filterName.filter((f) => f !== "email")
    : filterName.includes("ecom")
    ? filterName.filter((f) => f !== "ecom")
    : filterName.includes("chart")
    ? filterName.filter((f) => f !== "chart")
    : filterName.includes("editor")
    ? filterName.filter((f) => f !== "editor")
    : filterName;
  return (
    <div className={`header ${headerFix ? "is-fixed" : ""}`}>
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left"></div>
            <div className="navbar-nav header-right">
              <div className="dz-side-menu">
                <div className="sidebar-social-link "></div>
                <ul>
                  <Dropdown
                    as="li"
                    className="nav-item dropdown header-profile"
                  >
                    <Dropdown.Toggle
                      variant=""
                      as="a"
                      className="nav-link i-false c-pointer"
                    >
                      <img
                        src={
                          profileInfo?.image
                            ? profileInfo?.image
                            : "https://icon-library.com/images/default-profile-icon/default-profile-icon-24.jpg"
                        }
                        alt=""
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      align="right"
                      className="dropdown-menu dropdown-menu-end"
                    >
                      <LogoutPage />
                    </Dropdown.Menu>
                  </Dropdown>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
